import { render, staticRenderFns } from "./TaskAction.vue?vue&type=template&id=1ce3b982&scoped=true&"
import script from "./TaskAction.vue?vue&type=script&lang=js&"
export * from "./TaskAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce3b982",
  null
  
)

export default component.exports